var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main__select" }, [
    _vm.label
      ? _c(
          "label",
          { style: _vm.disabled ? "color:gray;" : null },
          [
            _vm._v(_vm._s(_vm.label)),
            _vm.hasPopOver
              ? _c("PopOver", _vm._b({}, "PopOver", _vm.popOver, false))
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "multi__select" }, [
      _c(
        "div",
        {
          staticClass: "selected_option",
          class: { focused: _vm.showOptions, disabled: _vm.disabled },
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              _vm.showOptions = _vm.disabled ? false : !_vm.showOptions
            }
          }
        },
        [
          !_vm.singleSelect &&
          _vm.optionsSelected &&
          _vm.optionsSelected.length > 0
            ? _c(
                "div",
                _vm._l(_vm.optionsSelected, function(option, index) {
                  return _c("div", { key: index, staticClass: "option" }, [
                    _c("span", [
                      _vm._v(_vm._s(option.name ? option.name : option))
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "remove",
                        on: {
                          click: function($event) {
                            return _vm.removeOption(option)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-times" })]
                    )
                  ])
                }),
                0
              )
            : _vm.singleSelect && _vm.optionsSelected
            ? _c("div", { staticClass: "single_option" }, [
                _vm.hasImage &&
                _vm.optionsSelected.image &&
                _vm.optionsSelected.image.imageURL
                  ? _c("img", {
                      attrs: {
                        src: _vm.optionsSelected.image.imageURL,
                        alt: "",
                        srcset: ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.optionsSelected.name
                        ? _vm.optionsSelected.name
                        : _vm.optionsSelected
                    )
                  )
                ])
              ])
            : _c("span", [_vm._v(_vm._s(_vm.placeholder))]),
          _vm._v(" "),
          _vm.showOptions && !_vm.disabled
            ? _c(
                "span",
                {
                  staticClass: "drop_down_arrow",
                  on: {
                    click: function($event) {
                      _vm.showOptions = !_vm.showOptions
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-angle-up" })]
              )
            : _c(
                "span",
                {
                  staticClass: "drop_down_arrow",
                  on: {
                    click: function($event) {
                      _vm.showOptions = !_vm.showOptions
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-angle-down" })]
              )
        ]
      ),
      _vm._v(" "),
      _vm.showOptions
        ? _c(
            "ul",
            _vm._l(_vm.optionsList, function(option, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: {
                    selected:
                      !option.name && _vm.optionsSelected.includes(option)
                  },
                  on: {
                    mousedown: function($event) {
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      return _vm.setSelectedOption(option)
                    },
                    mouseenter: function($event) {
                      return _vm.setHoverOption(option)
                    },
                    mouseleave: function($event) {
                      return _vm.setHoverOption(null)
                    }
                  }
                },
                [
                  _vm.hasImage && option.image && option.image.imageURL
                    ? _c("img", {
                        attrs: {
                          src: option.image.imageURL,
                          alt: "",
                          srcset: ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n                 " +
                      _vm._s(option.name ? option.name : option) +
                      " "
                  ),
                  option.icon
                    ? _c("Icon", { attrs: { icon: option.icon } })
                    : _vm._e(),
                  _vm._v(" "),
                  option.childrens && _vm.hoveredOption == option.name
                    ? _c(
                        "ul",
                        { staticClass: "childrens__option" },
                        _vm._l(option.childrens, function(item, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              class: {
                                selected: _vm.optionsSelected.includes(item)
                              },
                              on: {
                                mousedown: function($event) {
                                  return _vm.setSelectedOption(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item))]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6db79db0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db79db0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Select.vue
// module id = null
// module chunks = 